var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgHeartOutlineRed = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.485 2.757.38.452.383-.449c.491-.574.905-1.004 1.39-1.299.47-.286 1.035-.461 1.849-.461.232 0 .443 0 .67.02 1.293.123 2.9 1.315 3.1 3.791v.865c-.196 2.315-1.942 5.327-7.388 9.211C2.443 11.003.697 7.992.5 5.676v-.844C.7 2.355 2.309 1.163 3.58 1.04l.05-.004c.235-.02.428-.036.62-.036.816 0 1.381.17 1.85.454.483.291.896.72 1.385 1.303z",
    stroke: "#C62032"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHeartOutlineRed, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/heartOutlineRed.33d5c21c.svg";
export { ForwardRef as ReactComponent };